require('./style.less');

var Backbone = require('backbone'),
    GraphicNoteToolbarState = require('./graphicNoteToolbarState'),
    ShapeToolbar = require('../shapeToolbar'),
    ColorSelector = require('./colorSelector/colorSelector'),
    StrokeWidthSelector = require('./strokeWidthSelector/strokeWidthSelector'),
    BabySitterView = require('../../../../../common/BabySitterView'),
    fvChannel = require('glRadio').channel('FV');

/*
*
* TODO: separate out into 2 ways, one with a wrapper for the dropdowns and the toolbar
*
* */

module.exports = ShapeToolbar.extend({

    template: require('./graphicNoteToolbar'),

    id: 'graphicNoteTB',

    ui: _.extend( ShapeToolbar.prototype.ui, {
        strokeWidthDDBtn: '#strokeWidth',
        colorPickerDDBtn: '#colorPicker'
    }),

    initialize: function(options) {

        BabySitterView.prototype.createChildren.call(this);
        ShapeToolbar.prototype.initialize.call(this, options);

        this.state = new GraphicNoteToolbarState();

        this.channel = options.channel; //listened to by children
        this.channel.reply(this.requests, this);

        Marionette.bindEntityEvents(this, this.channel, this.channelEvents);

        this.listenTo( this.note, 'colorPicker:toggleEnabled', this.colorPickerToggleEnabled );

    },
    requests: {

        // Note: this now returns the entire state, which includes the select shape type
        drawingAttrs: function() {
            return this.state.toJSON();
        }

    },
    channelEvents: {
        'colorPicker:setColor':         'setColor',
        'strokeView:setWidth':          'setStrokeWidth'
    },
    onRender: function() {

        ShapeToolbar.prototype.onRender.apply(this, arguments); // may need to

        var $ddContainer = this.channel.request('vChannel').request('getWrapper');

        this.children
            .add( new StrokeWidthSelector({
                channel: this.channel,
                el: this.ui.strokeWidthDDBtn,
                ddOptions: {
                    hPos: 'right',
                    isSelect: true,
                    selectNoOpenerText: true,
                    defaultWidth: this.state.get('stroke-width'),
                    container: $ddContainer
                }
            }), 'strokeWidthSelector')

            /* TODO: complicated to convert to dd wrapper now: do later when change from Raphael anyway */

            .add( new ColorSelector({
                parent: this,
                channel: this.channel,
                el: this.ui.colorPickerDDBtn,
                color:  this.state.get('color'),
                container: $ddContainer
            }), 'colorSelector')

            .call('render');

            this.colorPickerToggleEnabled( );

    },

    /**
     * Override to get from the state, not necessarily the default type of the note.
     */
    _getTypeShapeTypeToSetOnRender: function() {
        return this.state.get('shapeType');
    },

    setActiveButton: function( shapeType ) {

        ShapeToolbar.prototype.setActiveButton.apply( this, arguments );
        this.state.setShapeType( shapeType );

    },

    setColor: function(color) {

        this.state.setColor( color );

        // TODO: rid and just pass off sandbox instance when get rid of 'outer mediator' (and forward)
        this.channel.trigger('notes:setDrawColor', color);
    },
    setStrokeWidth: function(width) {

        this.state.setStrokeWidth(width);

        //TODO: rid and just pass off sandbox instance when get rid of 'outer mediator'
        this.channel.trigger('notes:setDrawStrokeWidth', width);
    },

    colorPickerToggleEnabled: function( ) {

        this.children.findByCustom( 'colorSelector' ).toggleDisabled( this.note.disableColorPickerDueToColorRules( ) );

    },


    destroy: function() {

        BabySitterView.prototype.destroy.apply(this, arguments);

    }

});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/header/shapeDrawingToolbars/graphicNoteTB/graphicShapeToolbar.js
 ** module id = 506
 ** module chunks = 0
 **/